import React from 'react';
import PropTypes from 'prop-types';
import Layout from '~/components/Layout/Layout';
import AuthorCard from '~/components/AuthorCard/AuthorCard';
import Ad, { AdTypes } from '~/containers/AdContainer/AdContainer';
import { Link } from '~/routes';

import { initStore } from '~/state/store';
import withState from '~/hocs/withState';

import fetch from '~/util/fetch';

/* global CMS_API_URL */

const sortAuthors = authors =>
  authors.sort((author1, author2) => {
    const name1 = author1.name.toUpperCase();
    const name2 = author2.name.toUpperCase();

    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }

    return 0;
  });

class AuthorsDirectory extends React.Component {
  static async getInitialProps() {
    const authors = await fetch(`${CMS_API_URL}/authors`).then(response => response.json());

    return {
      authors: sortAuthors(authors.authors),
    };
  }

  render() {
    const { authors } = this.props;

    return (
      <Layout>
        <Ad adType={AdTypes.LEADERBOARD} />
        <div
          style={{
            padding: '20px',
            fontWeight: 'normal',
            fontSize: '24px',
          }}
        >
          Authors
        </div>
        <div
          className="row"
          style={{ padding: '10px 10px 40px 10px', borderTop: '1px solid #232323' }}
        >
          {authors.filter(author => /^(supervisor|editor)$/.test(author.job)).map(author => (
            <Link key={author.id} route={`/author/${author.slug}`}>
              <a className="col-xs-12 col-sm-6 col-md-4">
                <AuthorCard author={author} />
              </a>
            </Link>
          ))}
        </div>
      </Layout>
    );
  }
}

const authorShape = PropTypes.shape({
  name: PropTypes.string,
  headshot: PropTypes.object,
  bio: PropTypes.string,
  id: PropTypes.number,
});

AuthorsDirectory.propTypes = {
  authors: PropTypes.arrayOf(authorShape).isRequired,
};

export default withState({ createStore: initStore })(AuthorsDirectory);
